import { render, staticRenderFns } from "./ViewLearningRecords.vue?vue&type=template&id=2267b177"
import script from "./ViewLearningRecords.vue?vue&type=script&lang=js"
export * from "./ViewLearningRecords.vue?vue&type=script&lang=js"
import style0 from "./ViewLearningRecords.vue?vue&type=style&index=0&id=2267b177&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports